import VueRouter from "vue-router";
import Vue from "vue";
import welcomeRoutes from "../welcome";
import adminRoutes from "../admin";
import corporateRoutes from "../corporate";
import AOS from 'aos';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [...welcomeRoutes, ...corporateRoutes, ...adminRoutes],
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    const user = window.user;

    // Auth Checks
    if (to.meta.requiresAuth && !user.email) {
        window.location = "/admin/login";
        return;
    }

    if (to.meta.requiresCorporateAuth && !user.email) {
        window.location = "/business/auth";
        return;
    }

    if (to.meta.permission) {
        const hasPermission = user.permissions?.some(p => p.name === to.meta.permission);

        if (!hasPermission) {
            return next({ path: '/business/access-denied' });
        }
    }

    next();
});

router.afterEach((to, from) => {
    setTimeout(() => {
        AOS.init();
        AOS.refresh();
        window.scrollTo(0, 0);
    }, 100);
});

export default router;
